import React, { Component } from 'react';
import ModalHeader from 'react-bootstrap/ModalHeader';
import ModalTitle from 'react-bootstrap/ModalTitle';
import {findObjVal} from '../../../utils/helpers.utils';
import { REQUEST_STATUS, REQUEST_STATUS_TXT, ORDER_STATUS_TEXT as OrderStatus } from '../../../constants/external-constants';
export class ModalHeaderOrderRequestDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            status: "",
            css: ""
        }
    }

    getStatusValue = (id) =>{
        const result = OrderStatus.filter(obj => obj.id === id);
        const [obj] = result;
        this.setState(prev => ({...prev, status: obj?.value, css: obj?.customClass}))
    }

    componentDidMount(){
        this.getStatusValue(this.props.status);
    }
    componentDidUpdate(prevProps) {
        if (this.props.status !== prevProps.status) {
            this.getStatusValue(this.props.status); 
        }
    }
    render() {
    
        return (
            <ModalHeader closeButton>
                <ModalTitle>{this.props.title}
                    {this.props.status !== undefined ?
                        <span className={`${this.state.css} modal-header-status`}>  &nbsp; {` ${this.state.status}`}</span>   
                        : ""
                    }
                </ModalTitle>
            </ModalHeader>
        )
    }
}
